import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation, EventEmitter, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CommonDataService } from '../../services/common-data.service';
import { ConfigurationService } from '../../services/configuration.service';
import { GraphqlService } from '../../services/graphql.service';
import { LoginService } from '../../services/Login.service';
import { SessionService } from '../../services/Session.service';
import { AuthenticatedResponse } from '../../../components/Login/pro-view-login/pro-view-login.component';

@Component({
  selector: 'app-terms-and-condition-content',
  templateUrl: './terms-and-condition-content.component.html',
  styleUrls: ['./terms-and-condition-content.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class TermsAndConditionContentComponent implements OnInit {

  constructor(
    public sanitizer: DomSanitizer,
    private loginService: LoginService,
    private graphqlService: GraphqlService,
    private _configurationservice: ConfigurationService,
    private router: Router, private session: SessionService,
    public commonDataService: CommonDataService
  ) {

  }
  showlogo=false;
  showActionBtns: boolean = false;
  logo: any;
  @Output() myEvent = new EventEmitter<string>();
  usertype: string;
  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.commonDataService.tcsource.subscribe(data => {
      if (data == "pendingcontentsystem") {
        this.getPendingSystemContent();
        this.commonDataService.closeModalOption.subscribe(dataBool => {
          if (this.router.url != "/terms-and-conditions") {
            this.showActionBtns = !dataBool;
          }
        })
      }
      else {
        if (this.router.url.includes("TermsandConditions")) {
          this.addLogo();
        }
        else {
          this.checkSession();
          this.commonDataService.closeModalOption.subscribe(dataB => {
            if (this.usertype != 'Professional' && this.usertype != 'Academic') {
              if (this.router.url != "/terms-and-conditions") {
                this.showActionBtns = !dataB;
              }
            }
          })
        }
      }
    })
    if (this.apiResponse != undefined) {
      this.body = this.sanitizer.bypassSecurityTrustHtml(this.apiResponse.data?.component?.content?.data?.Article?.$values[0]?.body);
    }
  }

  addLogo() {
    this.showlogo = true;
    this.loadLogo();
    this.getProfessionalView()
  }
  loadLogo() {
    let hasLogo = localStorage.getItem("asc_logo");
    if (hasLogo) {
      this.logo = this.sanitizer.bypassSecurityTrustUrl(hasLogo);
    }
    else {
      this.graphqlService.getS3BucketImageASCLogo().subscribe(data => {
        this.logo = this.sanitizer.bypassSecurityTrustUrl(data);
        localStorage.setItem("asc_logo", data);
      });
    }
  }
  checkSession() {

    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        if (data != null && data.user != null && data.user.roles != null && data.user.roles != "null") {
          this.usertype = data.user.roles;
          if (data.user.roles == "Basic") {
            this.getBasicView()
          }
          else if (data.user.roles == "Professional" || data.user.roles == "Academic") {
            this.getProfessionalView();

          }
        } else {
          this.getBasicView();
        }

        this.session.assignUserInfo(data?.user);
      })
    }
    else {
      if (this.session.userInfo != null && this.session.userInfo.user.roles != null && this.session.userInfo.user.roles != "null") {
        this.usertype = this.session.userInfo.user.roles;
        if (this.session.userInfo.user.roles == "Basic") {
          this.getBasicView()
        }
        else if (this.session.userInfo.user.roles == "Professional") {
          this.getProfessionalView();

        }
      } else {
        this.getBasicView();
      }
    }
  }


  doNotAccept() {
    this.closeOverlay();
  }

  invalidLogin: boolean = false;
  accept() {
    localStorage.setItem("AcceptedT&C", "true");
    this.loginService.validateBasicView().subscribe({
      next: (response: AuthenticatedResponse) => {
        this.invalidLogin = false;
        this.session.assignUserInfo((<any>response).user);
        setTimeout(() => {
          this.commonDataService.closeModalOption.next(true);
        }, 500);
        this.closeOverlay();
        this.router.navigateByUrl("/Home");
      },
      error: (err: HttpErrorResponse) => {
        console.log(err);
        this.invalidLogin = true;
      }
    })
  }

  closeOverlay() {
    this.myEvent.emit();
  }

  getBasicView() {
    this.graphqlService.getTcBasicView().subscribe(data => {
       this.apiResponse = data;
       this.body = this.sanitizer.bypassSecurityTrustHtml(this.apiResponse.content.data.article[0].body);
       this.commonDataService.showLoader.next(false);
    })
  }

  getProfessionalView() {
    this.graphqlService.getTcProfessionalView().subscribe(data => {
       this.apiResponse = data;
       this.body = this.sanitizer.bypassSecurityTrustHtml(this.apiResponse.content.data.article[0].body);
       this.commonDataService.showLoader.next(false);
    })
  }
  getPendingSystemContent() {
    this.graphqlService.getTCPendingContentSystem().subscribe(data => {
      this.apiResponse = data;
      this.body = this.sanitizer.bypassSecurityTrustHtml(this.apiResponse.content.data.article[0].body);
      this.commonDataService.showLoader.next(false);
    })
  }

  printPage() {
    var contents = document.getElementById("printArticle").innerHTML;
    var frame1 = document.createElement('iframe');
    frame1.name = "frame1";
    frame1.style.position = "absolute";
    frame1.style.top = "-1000000px";
    document.body.appendChild(frame1);
    var frameDoc = (frame1.contentWindow)
    if (frameDoc && frameDoc.document) {
      frameDoc.document.open();
      frameDoc.document.write('<html><head></head><body>');
      frameDoc.document.write(contents);
      frameDoc.document.write('</body></html>');
      frameDoc.document.close();
    }
    setTimeout(function () {
      if (window != null && window.frames["frame1"] != null) {
        window.frames["frame1"].focus();
        window.frames["frame1"].print();
      }
      document.body.removeChild(frame1);
    }, 500);
  }

  body;
  apiResponse;
}
